"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Divider.default;
  }
});

var _Divider = _interopRequireDefault(require("./Divider"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Divider/index.js
// module id = 533
// module chunks = 0